export default __webpack_public_path__ + "static/media/palinsesto.f74d1db0.png";